import React from 'react';
import styles from './SquaredImage.module.scss';
import designPlaceholder from '../../assets/Design.png';
import { cleanupHttpPath } from '../../helpers/utils';
interface ISquaredImage {
  image?: string;
  altText?: string;
  placeholder?: string;
  circle?: boolean;
}

const SquaredImage: React.FC<ISquaredImage> = ({ image, altText, placeholder = designPlaceholder, circle }) => {
  const [cleanImage, setCleanImage] = React.useState<string | undefined>(undefined);
  React.useEffect(() => {
    setCleanImage(cleanupHttpPath(image));
  }, [image]);

  return (
    <div className={`${styles.squaredImageWrapper} ${circle ? styles.circle : ''}`}>
      <div className={`${styles.imageInner} `}>
        <img src={cleanImage ?? placeholder} alt={altText} />
      </div>
    </div>
  );
};

export default SquaredImage;
